import Api from '../Api.js';
import BaseView from './_BaseView.js';
import Table from "../components/Table";
import Confirm from "../components/Confirm";

export default class AppsView extends BaseView {
    constructor() {
        super();
        this.formSelector = '#appForm';
        this.formUrl = '/api/apps';
        this.formTpl = 'app-form-simple';
        this.formTitle = Lang.app;
        this.defaultObject = {
            title: '',
            host: ''
        };
        this.formCallback = function () {
            this.table.reload();
        };
    }

    init() {
        super.init();
        // const cards = new Card($('#apps'), {
        //     url: '/api/apps',
        //     requestData: {
        //         org: $('[data-org]').data('org')
        //     },
        //     tpl: 'apps',
        //     formTpl: 'app-form',
        //     default: {
        //         title: 'New Application',
        //         description: '',
        //         active: true,
        //         host: 'https://example.com',
        //     },
        //     getFormData: function ($form) {
        //         const data = $form.aeroSerialize();
        //         data.org = $('[data-org]').data('org');
        //         data.enterprise = !!(data.enterprise);
        //         data.aliases = [];
        //
        //         //Remove trailing slash
        //         data.host = data.host.replace(/\/$/, '');
        //
        //         $form.find('.alias-input').each(function () {
        //             let alias = $(this).val();
        //             if (alias) {
        //                 alias = alias.replace(/\/$/, '');
        //                 data.aliases.push(alias);
        //             }
        //         });
        //         return data;
        //     },
        //     validate: function ($card) {
        //         var $host = $card.find('input[name="host"]');
        //
        //         //Validate URL
        //
        //         var regex = new RegExp(
        //             "^" +
        //             // protocol identifier
        //             "(?:(?:https?|ftp)://)" +
        //             // user:pass authentication
        //             "(?:\\S+(?::\\S*)?@)?" +
        //             "(?:" +
        //             // IP address exclusion
        //             // private & local networks
        //             "(?!(?:10|127)(?:\\.\\d{1,3}){3})" +
        //             "(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})" +
        //             "(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})" +
        //             // IP address dotted notation octets
        //             // excludes loopback network 0.0.0.0
        //             // excludes reserved space >= 224.0.0.0
        //             // excludes network & broacast addresses
        //             // (first & last IP address of each class)
        //             "(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])" +
        //             "(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}" +
        //             "(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))" +
        //             "|" +
        //             // host name
        //             "(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)" +
        //             // domain name
        //             "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*" +
        //             // TLD identifier (Commented line below so it allows hostnames without a domain)
        //             //"(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))" +
        //             // TLD may end with dot
        //             "\\.?" +
        //             ")" +
        //             // port number
        //             "(?::\\d{2,5})?" +
        //             // resource path
        //             "(?:[/?#]\\S*)?" +
        //             "$", "i"
        //         );
        //
        //         return regex.test($host.val());
        //     }
        // });
        // cards.init();

        if ($('#manageApps').length > 0) {
            this.table = new Table('manageApps', `/api/apps/table?organization_id=${$('[data-org]').data('org')}`, [
                {data: 'title', orderable: true},
                {data: 'description'},
                {data: 'host'},
                {data: 'active'},
                {data: 'tools', orderable: false},
            ]);
        }
    }

    // renderForm(app) {
    //     const self = this;
    //     let method, url;
    //     if (!app) {
    //         app = {
    //             title: '',
    //             host: '',
    //         };
    //         method = 'post';
    //         url = '/api/apps';
    //     } else {
    //         method = 'patch';
    //         url = `/api/apps/${app.id}`;
    //     }
    //
    //     Api.getTpl('app-form-simple').done(function (r) {
    //         const tpl = _.template(r);
    //
    //         Confirm({
    //             ok: Lang.save,
    //             title: Lang.app,
    //             msg: tpl({item: app}),
    //             onValidate: function () {
    //                 return $('#appForm').isFormValid();
    //             },
    //             onConfirm: function () {
    //                 const data = $('#appForm').aeroSerialize();
    //                 data.active = !!(data.active);
    //                 data.enterprise = !!(data.enterprise);
    //                 data.org = $('[data-org]').data('org');
    //
    //                 Api.send(url, data, method).done(function () {
    //                     self.table.reload();
    //                 });
    //
    //             }
    //         });
    //     });
    // }

    getFormData() {
        const data = super.getFormData();
        data.active = !!(data.active);
        data.enterprise = !!(data.enterprise);
        data.isFrame = !!(data.isFrame);
        //data.isBeta = !!(data.isBeta);
        data.org = $('[data-org]').data('org');
        data.aliases = [];

        //Remove trailing slash
        data.host = data.host.replace(/\/$/, '');

        $(this.formSelector).find('.alias-input').each(function () {
            let alias = $(this).val();
            if (alias) {
                alias = alias.replace(/\/$/, '');
                data.aliases.push(alias);
            }
        });
        return data;
    }

    validateForm() {
        let valid = super.validateForm();
        const $host = $(this.formSelector).find('input[name="host"]');

        //Validate URL

        const regex = new RegExp(
            "^" +
            // protocol identifier
            "(?:(?:https?|ftp)://)" +
            // user:pass authentication
            "(?:\\S+(?::\\S*)?@)?" +
            "(?:" +
            // IP address exclusion
            // private & local networks
            "(?!(?:10|127)(?:\\.\\d{1,3}){3})" +
            "(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})" +
            "(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})" +
            // IP address dotted notation octets
            // excludes loopback network 0.0.0.0
            // excludes reserved space >= 224.0.0.0
            // excludes network & broacast addresses
            // (first & last IP address of each class)
            "(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])" +
            "(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}" +
            "(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))" +
            "|" +
            // host name
            "(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)" +
            // domain name
            "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*" +
            // TLD identifier (Commented line below so it allows hostnames without a domain)
            //"(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))" +
            // TLD may end with dot
            "\\.?" +
            ")" +
            // port number
            "(?::\\d{2,5})?" +
            // resource path
            "(?:[/?#]\\S*)?" +
            "$", "i"
        );

        return regex.test($host.val()) && valid;
    }

    setEvents() {
        super.setEvents();
        const self = this;
        const body = $('body');
        const container = $('#apps');
        const manage = $('#manageApps');

        container.off("click.pathsa").on("click.pathsa", '.save', function () {
            if ($('.alias-wrapper').is(':visible')) {
                $('.add-alias').click();
            }
            return false;
        });

        //Show aliases
        body.off('click.alias').on('click.alias', '.add-alias', function () {
            //Toggle display
            const $back = $(this).parents('.back, .app-form');
            const display = $back.find('.alias').is(':visible');

            if (!display) {
                $back.find('.alias-wrapper').css({display: 'inherit'});
                $back.find('.add-alias i').removeClass('jsicon-caret-down').addClass('jsicon-caret-up');
            } else {
                $back.find('.alias-wrapper').hide();
                $back.find('.add-alias i').removeClass('jsicon-caret-up').addClass('jsicon-caret-down');
            }
        });

        //Add alias input box
        body.off('click.aliasb').on('click.aliasb', '.add-alias-btn', function () {

            //Check if card expanded
            const $back = $(this).parents('.back, .app-form');
            const expanded = $back.find('.alias-wrapper').is(':visible');

            //Add new input field
            const $html = $(
                `<label class="alias aero-label aero-button-input">
                        <input class="alias-input" type="text" placeholder="http://uat.example.com">
                        <a class="btn btn-dark delete-alias"><i class="jsicon-wrong"></i></a>
                    </label>`
            );
            $back.find('.alias-wrapper').append($html);

            //Expand card
            if (!expanded) {
                $back.find('a.add-alias').click();
            }
            return false;
        });

        //Delete alias
        body.off('click.aliasd').on('click.alaisd', '.delete-alias', function () {
            $(this).parents('.alias:eq(0)').remove();
            return false;
        });

        manage.on('click', '.edit', function () {
            const id = $(this).parents('div:eq(0)').data('id');

            Api.send(`/api/apps/${id}`).done(function (r) {
                self.renderForm(r);
            });
            return false;
        });

        // delete
        manage.on('click.appdel', '.delete', function () {
            const id = $(this).parents('div:eq(0)').data('id');
            Confirm({
                ok: Lang.delete,
                title: name,
                msg: `${Lang.delsure}<br><br><strong class="msg-box danger">${Lang.delundone}</strong>`,
                onConfirm: function () {
                    Api.send(`/api/apps/${id}`, {}, 'delete').done(function () {
                        self.table.reload();
                    });
                }
            });
        });

        $('.add-app-simple').on('click', function () {
            self.renderForm();
            return false;
        });

    }
}
